module.exports = __webpack_public_path__ + "static/media/base.7ccef680.svg";